// extracted by mini-css-extract-plugin
export default {"pad":"Home_pad__6AHXg"};